<template>
  <v-col :cols="cols">
    <horizontal-bar :chart-data="datacollection" :height="height" :style="style"></horizontal-bar>
  </v-col>
</template>

<script>
import HorizontalBar from "./HorizontalBar.js";
import { colors } from "./color-sets.js";

export default {
  components: {
    HorizontalBar
  },
  props: ['height', "style", "cols", 'dimensions', 'aggregatedValues'],
  computed: {
    datacollection() {
      return this.horizontalBarChartDataCollection(
        this.dimensions,
        this.aggregatedValues
      );
    }
  },
  methods: {
    horizontalBarChartDataCollection: (dimensions, aggregatedValues) => {
      let labels = [];
      let datasets = [];
      if (dimensions.length == undefined || dimensions.length == 0) {
        return {
          labels: [],
          datasets: []
        };
      }
      labels = aggregatedValues[dimensions[0]]
        .sort((a, b) => a.id - b.id)
        .map(item => {
          return item.name;
        });
      dimensions.map((dimension, index) => {
        let values = [];
        let backgroundColor = colors[index % colors.length];
        aggregatedValues[dimension]
          .sort((a, b) => a.id - b.id)
          .map(item => {
            values.push(item.value);
          });
        datasets.push({
          label: dimension,
          backgroundColor: backgroundColor,
          borderColor: "#000000",
          borderWidth: 1,
          data: values
        });
      });
      return {
        labels: labels,
        datasets: datasets
      };
    }
  }
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>